import { G } from '@mobily/ts-belt';
import { useRecordContext } from 'react-admin';

import { maskEmail } from '@sh4res/bo-common/utils/maskEmail';

type MaskedEmailFieldProps = {
  source: string;
  testId?: string;
};

export const MaskedEmailField = ({ source, testId }: MaskedEmailFieldProps) => {
  const record = useRecordContext<Record<string, string | null>>();
  const value = record?.[source];

  if (G.isNullable(value) || value === '') {
    return <span data-testid={testId}>-</span>;
  }

  return <span data-testid={testId}>{maskEmail(value)}</span>;
};
